module.exports = __webpack_public_path__ + "img/img-apple-store-download@3x.0350b55f.jpg";